import { LoginTokenComponent } from '@components/shared/login-token/login-token.component';
import { TranslateModule } from '@ngx-translate/core';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { differenceInCalendarDays, format, parseISO } from 'date-fns';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-booking-quick-info',
  standalone: true,
  imports: [CommonModule, TranslateModule, LoginTokenComponent],
  templateUrl: './booking-quick-info.component.html'
})
export class BookingQuickInfoComponent {
  @Input() booking: IBookingModel | null = null;

  /**
   * Calculate and return the stay duration in nights
   */
  get stayDuration(): number {
    if (!this.booking?.start_date || !this.booking?.end_date) return 0;

    const startDate = typeof this.booking.start_date === 'string' ? parseISO(this.booking.start_date) : this.booking.start_date;

    const endDate = typeof this.booking.end_date === 'string' ? parseISO(this.booking.end_date) : this.booking.end_date;

    return differenceInCalendarDays(endDate, startDate);
  }

  /**
   * Format the start date for display
   */
  get formattedStartDate(): string {
    if (!this.booking?.start_date) return '';

    const date = typeof this.booking.start_date === 'string' ? parseISO(this.booking.start_date) : this.booking.start_date;

    return format(date, 'yyyy. MM. dd.');
  }

  /**
   * Format the end date for display
   */
  get formattedEndDate(): string {
    if (!this.booking?.end_date) return '';

    const date = typeof this.booking.end_date === 'string' ? parseISO(this.booking.end_date) : this.booking.end_date;

    return format(date, 'yyyy. MM. dd.');
  }
}
